import { combineReducers } from 'redux';

import auth from './auth';
import alerts from './alert';
import users from './users';
import config from './config';
import vatRates from './vatRates';
import addresses from './addresses';
import company from './company';
import warehouses from './warehouses';
import pointsOfSale from './pointsOfSale';
import hardware from './hardware';
import confirmation from './confirmation';

export default combineReducers({
  auth,
  alerts,
  confirmation,
  users,
  config,
  vatRates,
  addresses,
  company,
  warehouses,
  pointsOfSale,
  hardware,
});
